const testResponse = [{
  'lineItems': [{
      'sku': '01003876',
      'requestedQuantity': 5,
      'grandFatheredPricing': false,
      'name': 'ageLOC® Facial Gels',
      'oneTime': false
    },
    {
      'sku': '01003875',
      'requestedQuantity': 2,
      'grandFatheredPricing': false,
      'name': 'ageLOC® Product',
      'oneTime': true
    }
  ],
  'lineItemSkuList': ['01003876', '01003875'],
  'key': '951483746',
  'value': 'ADR#951483746',
  'isPrimaryAdr': true,
  'adrName': 'ageLOC® Facial Gels, ageLOC® Product',
  'payment': [{
    'id': '000001',
    'type': 'CCARD',
    'amount': 0,
    'Currency': null,
    'action': null,
    'AuthorizationStatus': null,
    'DeclineMessage': null,
    'CreditCard': {
      'Type': 'VISA',
      'CardNumber': '************3765',
      'AuthorizationCode': '',
      'Name': 'Johann Sebastian Bach II',
      'ExpirationMonth': '01',
      'ExpirationYear': '2020',
      'PostalCode': '84601',
      'VerificationCode': '',
      'EncryptedCardNumber': 'AFBWllCJHtiy+6zLZHUfNw==',
      'TrackOne': '',
      'Installments': null,
      'TransactionType': {
        'value': null,
        'PaymentPeriod': 0
      }
    },
    'Bank': null,
    'Custom': [{
        'Key': 'LIMIT',
        'Value': '59.48',
        'Type': 'AUTH'
      },
      {
        'Key': 'GUID',
        'Value': '0050569650891ED8ACD79DC364A1B4B9',
        'Type': 'PAYMENT'
      },
      {
        'Key': 'SORT_EXT',
        'Value': '      100',
        'Type': 'PAYMENT'
      }
    ],
    'Verification': null,
    'BillingAddress': null,
    'Messages': null,
    'AdditionalAuthorization': null
  }],
  'shipping': {
    'shipping': {
      'shippingMethods': [{
          'Code': 'PO',
          'Default': null,
          'Description': 'Post',
          'Cost': 0,
          'PickUpLocation': '',
          'Currency': null
        },
        {
          'Code': 'PU',
          'Default': null,
          'Description': 'Pick-Up',
          'Cost': 0,
          'PickUpLocation': 'CA02',
          'Currency': null
        },
        {
          'Code': 'PU',
          'Default': null,
          'Description': 'Pick-Up',
          'Cost': 0,
          'PickUpLocation': 'CA03',
          'Currency': null
        },
        {
          'Code': 'UG',
          'Default': null,
          'Description': 'UPS Grn Ground',
          'Cost': 0,
          'PickUpLocation': '',
          'Currency': null
        }
      ],
      'ShippingParty': [{
          'ShippingMemberID': 'CA00272590',
          'Type': 'SOLD_TO',
          'ShippingAddress': {
            'ID': 'CA00272590',
            'Name': 'Elisa Matthews',
            'CareOfName': '',
            'Address': {
              'Street1': '40 Petty St',
              'Street2': '',
              'City': 'Washington',
              'District': '',
              'DistrictDesc': null,
              'Region': 'D.C.',
              'RegionDesc': null,
              'PostalCode': '12342',
              'CountryCode': 'US',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [{
                'Country': '',
                'Value': {
                  'value': 'ematthews@email.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '613-866-9765',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [{
              'Key': 'NAME_GIVEN',
              'Value': 'Elisa',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'Matthews',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'DC',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'CA00272590',
          'Type': 'SHIP_TO',
          'ShippingAddress': {
            'ID': 'CA00272590',
            'Name': 'zhi_Hong Luo',
            'CareOfName': '',
            'Address': {
              'Street1': '502 Egret Way',
              'Street2': '',
              'City': 'NEPEAN',
              'District': '',
              'DistrictDesc': null,
              'Region': 'ON',
              'RegionDesc': null,
              'PostalCode': 'K2J 5V3',
              'CountryCode': 'CA',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [{
                'Country': '',
                'Value': {
                  'value': 'cuteboymax29@hotmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '6138668889',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [{
              'Key': 'NAME_GIVEN',
              'Value': '',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'zhi_Hong Luo',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'CAON',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'CA00272590',
          'Type': 'BILL_TO',
          'ShippingAddress': {
            'ID': 'CA00272590',
            'Name': 'luo, shaoan',
            'CareOfName': '',
            'Address': {
              'Street1': '40 Petty St',
              'Street2': '',
              'City': 'NEPEAN',
              'District': '',
              'DistrictDesc': null,
              'Region': 'ON',
              'RegionDesc': null,
              'PostalCode': 'K2G 0J2',
              'CountryCode': 'CA',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [{
                'Country': '',
                'Value': {
                  'value': 'shaoanluo@qq.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '613-866-9765',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [{
              'Key': 'NAME_GIVEN',
              'Value': 'shaoan',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'luo',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'CAON',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'CA00272590',
          'Type': 'PAYER',
          'ShippingAddress': {
            'ID': 'CA00272590',
            'Name': 'luo, shaoan',
            'CareOfName': '',
            'Address': {
              'Street1': '40 Petty St',
              'Street2': '',
              'City': 'NEPEAN',
              'District': '',
              'DistrictDesc': null,
              'Region': 'ON',
              'RegionDesc': null,
              'PostalCode': 'K2G 0J2',
              'CountryCode': 'CA',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [{
                'Country': '',
                'Value': {
                  'value': 'shaoanluo@qq.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '613-866-9765',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [{
              'Key': 'NAME_GIVEN',
              'Value': 'shaoan',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'luo',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'CAON',
              'Type': 'PARTNER'
            }
          ]
        },
        {
          'ShippingMemberID': 'CA00262732',
          'Type': 'SPONSOR',
          'ShippingAddress': {
            'ID': 'CA00262732',
            'Name': 'GENG, QIN',
            'CareOfName': '',
            'Address': {
              'Street1': '969 Rossburn Cres',
              'Street2': '',
              'City': 'NEPEAN',
              'District': '',
              'DistrictDesc': null,
              'Region': 'ON',
              'RegionDesc': null,
              'PostalCode': 'K2J 0Y5',
              'CountryCode': 'CA',
              'CountryCodeDesc': null,
              'InternationalAddresses': null
            },
            'Contact': [{
                'Country': '',
                'Value': {
                  'value': 'qingeng@hotmail.com',
                  'Type': 'EMAIL'
                }
              },
              {
                'Country': '',
                'Value': {
                  'value': '613-692-9557',
                  'Type': 'HOMEPHONE'
                }
              }
            ],
            'Instructions': ''
          },
          'Custom': [{
              'Key': 'NAME_GIVEN',
              'Value': 'QIN',
              'Type': 'PARTNER'
            },
            {
              'Key': 'NAME_FAMILY',
              'Value': 'GENG',
              'Type': 'PARTNER'
            },
            {
              'Key': 'TAXJURCODE',
              'Value': 'CAON',
              'Type': 'PARTNER'
            }
          ]
        }
      ],
      'ShippingMethod': {
        'Code': 'UG',
        'Default': null,
        'Description': 'UPS Grn Ground',
        'Cost': 8.5,
        'PickUpLocation': '',
        'Currency': null
      },
      'Tracking': null
    },
    'shippingMethods': [{
        'Code': 'PO',
        'Default': null,
        'Description': 'Post',
        'Cost': 0,
        'PickUpLocation': '',
        'Currency': null
      },
      {
        'Code': 'PU',
        'Default': null,
        'Description': 'Pick-Up',
        'Cost': 0,
        'PickUpLocation': 'CA02',
        'Currency': null
      },
      {
        'Code': 'PU',
        'Default': null,
        'Description': 'Pick-Up',
        'Cost': 0,
        'PickUpLocation': 'CA03',
        'Currency': null
      },
      {
        'Code': 'UG',
        'Default': null,
        'Description': 'UPS Grn Ground',
        'Cost': 0,
        'PickUpLocation': '',
        'Currency': null
      }
    ],
    'ShippingParty': [{
        'ShippingMemberID': 'CA00272590',
        'Type': 'SOLD_TO',
        'ShippingAddress': {
          'ID': 'CA00272590',
          'Name': 'luo, shaoan',
          'CareOfName': '',
          'Address': {
            'Street1': '40 Petty St',
            'Street2': '',
            'City': 'NEPEAN',
            'District': '',
            'DistrictDesc': null,
            'Region': 'ON',
            'RegionDesc': null,
            'PostalCode': 'K2G 0J2',
            'CountryCode': 'CA',
            'CountryCodeDesc': null,
            'InternationalAddresses': null
          },
          'Contact': [{
              'Country': '',
              'Value': {
                'value': 'shaoanluo@qq.com',
                'Type': 'EMAIL'
              }
            },
            {
              'Country': '',
              'Value': {
                'value': '613-866-9765',
                'Type': 'HOMEPHONE'
              }
            }
          ],
          'Instructions': ''
        },
        'Custom': [{
            'Key': 'NAME_GIVEN',
            'Value': 'shaoan',
            'Type': 'PARTNER'
          },
          {
            'Key': 'NAME_FAMILY',
            'Value': 'luo',
            'Type': 'PARTNER'
          },
          {
            'Key': 'TAXJURCODE',
            'Value': 'CAON',
            'Type': 'PARTNER'
          }
        ]
      },
      {
        'ShippingMemberID': 'CA00272590',
        'Type': 'SHIP_TO',
        'ShippingAddress': {
          'ID': 'CA00272590',
          'Name': 'John Smith',
          'CareOfName': '',
          'Address': {
            'Street1': '502 Egret Way',
            'Street2': '',
            'City': 'NEPEAN',
            'District': '',
            'DistrictDesc': null,
            'Region': 'ON',
            'RegionDesc': null,
            'PostalCode': 'K2J 5V3',
            'CountryCode': 'CA',
            'CountryCodeDesc': null,
            'InternationalAddresses': null
          },
          'Contact': [{
              'Country': '',
              'Value': {
                'value': 'johnsmith234@hotmail.com',
                'Type': 'EMAIL'
              }
            },
            {
              'Country': '',
              'Value': {
                'value': '6138668889',
                'Type': 'HOMEPHONE'
              }
            }
          ],
          'Instructions': ''
        },
        'Custom': [{
            'Key': 'NAME_GIVEN',
            'Value': '',
            'Type': 'PARTNER'
          },
          {
            'Key': 'NAME_FAMILY',
            'Value': 'John Smith',
            'Type': 'PARTNER'
          },
          {
            'Key': 'TAXJURCODE',
            'Value': 'CAON',
            'Type': 'PARTNER'
          }
        ]
      },
      {
        'ShippingMemberID': 'CA00272590',
        'Type': 'BILL_TO',
        'ShippingAddress': {
          'ID': 'CA00272590',
          'Name': 'luo, shaoan',
          'CareOfName': '',
          'Address': {
            'Street1': '40 Petty St',
            'Street2': '',
            'City': 'NEPEAN',
            'District': '',
            'DistrictDesc': null,
            'Region': 'ON',
            'RegionDesc': null,
            'PostalCode': 'K2G 0J2',
            'CountryCode': 'CA',
            'CountryCodeDesc': null,
            'InternationalAddresses': null
          },
          'Contact': [{
              'Country': '',
              'Value': {
                'value': 'shaoanluo@qq.com',
                'Type': 'EMAIL'
              }
            },
            {
              'Country': '',
              'Value': {
                'value': '613-866-9765',
                'Type': 'HOMEPHONE'
              }
            }
          ],
          'Instructions': ''
        },
        'Custom': [{
            'Key': 'NAME_GIVEN',
            'Value': 'shaoan',
            'Type': 'PARTNER'
          },
          {
            'Key': 'NAME_FAMILY',
            'Value': 'luo',
            'Type': 'PARTNER'
          },
          {
            'Key': 'TAXJURCODE',
            'Value': 'CAON',
            'Type': 'PARTNER'
          }
        ]
      },
      {
        'ShippingMemberID': 'CA00272590',
        'Type': 'PAYER',
        'ShippingAddress': {
          'ID': 'CA00272590',
          'Name': 'luo, shaoan',
          'CareOfName': '',
          'Address': {
            'Street1': '40 Petty St',
            'Street2': '',
            'City': 'NEPEAN',
            'District': '',
            'DistrictDesc': null,
            'Region': 'ON',
            'RegionDesc': null,
            'PostalCode': 'K2G 0J2',
            'CountryCode': 'CA',
            'CountryCodeDesc': null,
            'InternationalAddresses': null
          },
          'Contact': [{
              'Country': '',
              'Value': {
                'value': 'shaoanluo@qq.com',
                'Type': 'EMAIL'
              }
            },
            {
              'Country': '',
              'Value': {
                'value': '613-866-9765',
                'Type': 'HOMEPHONE'
              }
            }
          ],
          'Instructions': ''
        },
        'Custom': [{
            'Key': 'NAME_GIVEN',
            'Value': 'shaoan',
            'Type': 'PARTNER'
          },
          {
            'Key': 'NAME_FAMILY',
            'Value': 'luo',
            'Type': 'PARTNER'
          },
          {
            'Key': 'TAXJURCODE',
            'Value': 'CAON',
            'Type': 'PARTNER'
          }
        ]
      },
      {
        'ShippingMemberID': 'CA00262732',
        'Type': 'SPONSOR',
        'ShippingAddress': {
          'ID': 'CA00262732',
          'Name': 'GENG, QIN',
          'CareOfName': '',
          'Address': {
            'Street1': '969 Rossburn Cres',
            'Street2': '',
            'City': 'NEPEAN',
            'District': '',
            'DistrictDesc': null,
            'Region': 'ON',
            'RegionDesc': null,
            'PostalCode': 'K2J 0Y5',
            'CountryCode': 'CA',
            'CountryCodeDesc': null,
            'InternationalAddresses': null
          },
          'Contact': [{
              'Country': '',
              'Value': {
                'value': 'qingeng@hotmail.com',
                'Type': 'EMAIL'
              }
            },
            {
              'Country': '',
              'Value': {
                'value': '613-692-9557',
                'Type': 'HOMEPHONE'
              }
            }
          ],
          'Instructions': ''
        },
        'Custom': [{
            'Key': 'NAME_GIVEN',
            'Value': 'QIN',
            'Type': 'PARTNER'
          },
          {
            'Key': 'NAME_FAMILY',
            'Value': 'GENG',
            'Type': 'PARTNER'
          },
          {
            'Key': 'TAXJURCODE',
            'Value': 'CAON',
            'Type': 'PARTNER'
          }
        ]
      }
    ],
    'ShippingMethod': {
      'Code': 'UG',
      'Default': null,
      'Description': 'UPS Grn Ground',
      'Cost': 8.5,
      'PickUpLocation': '',
      'Currency': null
    },
    'Tracking': null
  },
  'products': [{
    'sku': '01003876',
    'requestedQuantity': 5,
    'grandFatheredPricing': false,
    'name': 'ageLOC® Facial Gels',
    'oneTime': false
  }],
  'oneTimeProducts': [{
    'sku': '01003875',
    'requestedQuantity': 2,
    'grandFatheredPricing': false,
    'name': 'ageLOC® Product',
    'oneTime': true
  }],
  'OrderID': '951483746',
  'TimeStamp': 20180220193740,
  'Editable': false,
  'NextDeliveryDate': 1529647200000,
  'OrderFrequency': 1,
  'shippingTotal': 45,
  'psvBalance': 304.35,
  'tax': 29.73,
  'total': 234.23,
  'subTotal': 200.32,
  'overriden': false,
  'held': true,
  'LastPlacedDate': null,
  'Scan': null
}];
module.exports.wrapperTestResponse = testResponse;
